import type {
  IncompleteAddress,
  IncompletePayment,
  DemonstratorSubscription, NameFields
} from '~/types/account'

export const defaultDemoSubscriptionFirst = (subscriptions: DemonstratorSubscription[]):DemonstratorSubscription[] => {
  const defaultDemoSubscription = subscriptions.find(el => el.defaultDemonstrator) || null
  if (!defaultDemoSubscription) {
    return subscriptions
  }
  const nonDefaultDemoSubscriptions = subscriptions.filter(el => !el.defaultDemonstrator)
  return [defaultDemoSubscription, ...nonDefaultDemoSubscriptions]
}

export const emptyAddress: () => IncompleteAddress = () => ({
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  city: '',
  county: '',
  suburb: '',
  postalCode: '',
  region: '',
  country: '',
  phoneNumber: '',
  defaultAddress: false
})

export const emptyNameFields: () => NameFields = () => ({
  firstName: '',
  lastName: ''
})

export const emptyPayment: () => IncompletePayment = () => ({
  paymentAuthorizationId: '',
  paymentType: '',
  maskedAccountNumber: '',
  accountLast4: '',
  isExpired: false,
  billingInfoId: '',
  status: '',
  cardName: '',
  expirationMonth: null,
  expirationYear: null,
  isDefaultPayment: false
})
